import { computed } from 'vue';
import { useStore } from 'vuex';

export const usePermission = () => {
  const store = useStore();

  const permissions = computed(() => store.getters.companyPermissions || []);

  const isCompanyUser = computed(() => store.getters.isCompanyUser);

  const hasPermission = (code, mode = 'some') => {
    if (!isCompanyUser.value) {
      return true;
    }

    if (!permissions.value || permissions.value.length === 0) {
      return false;
    }

    if (typeof code === 'string') {
      return permissions.value.includes(code);
    }

    if (Array.isArray(code)) {
      if (mode === 'every') {
        return code.every(item => permissions.value.includes(item));
      }
      return code.some(item => permissions.value.includes(item));
    }

    return false;
  };

  const setPermissions = permissionList => {
    store.commit('setCompanyPermissions', permissionList);
  };

  const clearPermissions = () => {
    store.commit('setCompanyPermissions', []);
  };

  return {
    permissions,
    hasPermission,
    setPermissions,
    clearPermissions
  };
};

export default usePermission;
